import styled from 'styled-components';

export const ErrorPageOuterWrapDiv = styled.div(
  props => `
  width: 70vw;
  display:flex;
  justify-content: space-between;
  align-items: center;
`,
);

export const ErrorPageLeftWrapper = styled.div(
  props => `
  
    // display:flex;
  
  `,
);

export const ErrorCode = styled.div(
  props => `
  
    font-size:${props.theme.font.custom(110)};
    color: ${props.theme.colors.goBrandBlue.medium};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
  
  `,
);

export const ErrorCodeDescrption = styled.p(
  props => `
  
    
    font-size:${props.theme.font.custom(45)};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
  `,
);

export const ErrorCodeSubDescription = styled.p(
  props => `
  
    
    font-size:${props.theme.font.custom(24)};
    margin-top:${props.theme.spacing.small};
  `,
);

export const NavigationList = styled.ul(
  props => `
   
    font-size:${props.theme.font.custom(18)};
    display:flex;
    margin-top:${props.theme.spacing.custom(30)};

>li{
    display:flex;
    &:last-child{
        border-right:none;
    }
  }
  `,
);

export const ListItem = styled.a(
  props => `

  padding: 0 ${props.theme.spacing.base};
  border-right:1px solid ${props.theme.colors.ash.dark};
`,
);

export const BodySection = styled.section(
  props => `
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: ${props.theme.colors.ash.medium};
    position: relative;
    align-items: center;
  `,
);
